<template>
    <div v-if="showPromo" class="promo-wrap">
        <div class="container">
            <div class="promo-strip glass">
                <div class="promo-left">
                    <span class="promo-emoji" aria-hidden="true">⚡</span>
                    <span class="promo-text">
            {{ text }}
          </span>
                </div>

                <div class="promo-actions">
                    <a :href="linkHref"
                       class="promo-more"
                       aria-label="Read giveaway terms">
                        {{ linkText }}
                    </a>

                    <button type="button"
                            class="promo-close"
                            @click="dismissPromo"
                            aria-label="Dismiss announcement">
                        &times;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PromoBanner',
    props: {
        text: {
            type: String,
            default: "10 Winners, $50 Each! Celebrate Magetsi’s 10th Anniversary💃🏽."
        },
        linkHref: { type: String, default: "/giveaway-terms" },
        linkText: { type: String, default: "Click for more" },
        storageKey: { type: String, default: "promoStripDismissed" }
    },
    data() {
        return { promoDismissed: false };
    },
    computed: {
        showPromo() { return !this.promoDismissed; }
    },
    mounted() {
        try {
            this.promoDismissed = localStorage.getItem(this.storageKey) === '1';
        } catch (e) {
            this.promoDismissed = false;
        }
    },
    methods: {
        dismissPromo() {
            this.promoDismissed = true;
            try { localStorage.setItem(this.storageKey, '1'); } catch (e) {}
            this.$emit('dismissed');
        }
    }
}
</script>

<style scoped>


.promo-wrap {
    padding: 8px 0;
    position: relative;
    z-index: 6;
}

.promo-strip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(37,44,101,0.78), rgba(59,71,140,0.78));
    color: #fff;
}

.promo-left {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.promo-emoji { font-size: 1.1rem; line-height: 1; }

.promo-text {
    font-weight: 700;
    letter-spacing: .2px;
    font-size: 0.98rem;
    line-height: 1.3;
    word-break: break-word;
}

.promo-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.promo-more {
    display: inline-block;
    padding: 8px 14px;
    background: rgba(255,255,255,0.9);
    color: #252c65;
    border-radius: 999px;
    font-weight: 700;
    font-size: 0.9rem;
    text-decoration: none;
    box-shadow: 0 2px 6px rgba(0,0,0,0.12);
    transition: transform .15s ease, background .2s ease;
}
.promo-more:hover,
.promo-more:focus {
    background: #ffffff;
    transform: translateY(-1px);
}


.promo-close {
    background: transparent;
    border: 0;
    color: #fff;
    font-size: 1.25rem;
    line-height: 1;
    padding: 4px 8px;
    opacity: .9;
    cursor: pointer;
}
.promo-close:hover { opacity: 1; }
@media (max-width: 576px) {
    .promo-strip {
        flex-direction: column;
        align-items: stretch;
        text-align: center;
        gap: 10px;
        padding: 12px;
    }
    .promo-actions {
        justify-content: center;
    }
    .promo-text { font-size: 0.94rem; }
}
</style>
